import React, { useState } from 'react';
import { useTheme, Menu, MenuItem, IconButton, ListItemIcon, makeStyles } from '@material-ui/core';
import { AccountCircleOutlined, ExitToAppOutlined } from '@material-ui/icons';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const textDecoration = {
  textDecoration: 'none',
  color: 'inherit'
};

const useStyles = makeStyles(theme => ({
  noDecoration: {
    textDecoration,
    '&:focus': textDecoration,
    '&:hover': textDecoration,
    '&:visited': textDecoration,
    '&:link': textDecoration,
    '&:active': textDecoration
  },
  backgroundColor: theme.palette.background.default
}));

const UserMenu = (props) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const classes = useStyles();
  const [color, setColor] = useState(classes.backgroundColor);
  const { t } = useTranslation();
  const { handleLogout } = props;
  const theme = useTheme();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton
        aria-controls='simple-menu'
        aria-haspopup='true'
        onClick={handleClick}
        color='primary'
        onMouseEnter={() => setColor('white')}
        onMouseLeave={() => setColor(theme.palette.primary.main)}>
        <AccountCircleOutlined fontSize='large' color='primary' style={{ color: `${color}` }} />
      </IconButton>
      <Menu
        id='simple-menu'
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        disableScrollLock
      >
        <MenuItem onClick={() => handleLogout()}>
          <ListItemIcon>
            <ExitToAppOutlined fontSize={'small'} />
          </ListItemIcon>
          {t('userMenu:exit')}
        </MenuItem>
      </Menu>
    </div>
  );
};

export default withRouter(UserMenu);
